<script>
  import formFieldMixin from './form-field-mixin.js'

  export default {
    mixins: [
      formFieldMixin
    ]
  }
</script>
<template>
  <b-form-group
    :description="description"
    :label="label"
    :label-for="inputName"
    :invalid-feedback="violations"
    :labelClass="labelClasses"
  >
    <input type=hidden :autocomplete="autocomplete" value="">
    <b-input-group>
      <b-form-input
        :id="inputName"
        :name="inputName"
        :value="value"
        type="text"
        @input="updateField($event)"
        :placeholder="placeholder"
        :state="!isInvalid"
      >
      </b-form-input>
      <b-input-group-append>
        <b-form-timepicker
          :id="inputName"
          :value="value"
          right
          @input="updateField($event)"
          now-button
          :label-now-button="$t('button.time-picker.now')"
          reset-button
          :label-reset-button="$t('button.time-picker.reset')"
          button-only
          no-close-button
          hide-header
          :aria-controls="inputName"
          :hour12="null"
        ></b-form-timepicker>
      </b-input-group-append>
      <slot></slot>
    </b-input-group>
  </b-form-group>
</template>
